<template>
    <div
        :class="{highlight: true}"
    >
        <div class="container">
            <div
                class="tag-container"
                v-if="tag"
            >
                <span class="tag">{{tag}}</span>
            </div>
            <div
                class="heading"
                v-html="layout.highlight.heading"
            ></div>
            <div
                class="baseline"
                v-html="layout.highlight.baseline"
            ></div>
        </div>
        <div class="footer">
            <span class="date">{{layout.date}}</span>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        layout: {
            type: Object,
            default() {}
        }
    },
    computed: {
        tag() {
            const tag = this.layout.tagLabel ? this.layout.tagLabel[0] : false
            return tag ? tag.name : false
        }
    }
}
</script>
<style lang="sass" scoped>
@import "@/styles/vars.sass"
.highlight
    background-color: rgb(243,243,243)
//     padding-top: 178px
//     padding-right: 75px
//     padding-bottom: 85px
//     padding-left: 85px
//     @include media-breakpoint-down($sm)
//         padding-top: 145px
//         padding-right: 51px
//         padding-bottom: 69px
//         padding-left: 69px
.container
    flex: 1
    display: flex
    flex-direction: column
.tag-container
    flex: 0.3
</style>
